import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format, parseISO, isValid } from 'date-fns'
import { de } from 'date-fns/locale'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDatum(date: string | null | undefined, fmt = 'dd.MM.yyyy'): string {
  if (!date) return '–'
  try {
    const d = parseISO(date)
    return isValid(d) ? format(d, fmt, { locale: de }) : date
  } catch {
    return date
  }
}

export function formatDatumZeit(date: string | null | undefined): string {
  return formatDatum(date, 'dd.MM.yyyy HH:mm')
}

export function formatWaehrung(betrag: number | null | undefined): string {
  if (betrag == null) return '–'
  return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(betrag)
}

export function berechneTotalOfferte(positionen: { menge: number; einzelpreis: number; rabatt: number }[]): number {
  return positionen.reduce((sum, p) => {
    const netto = p.menge * p.einzelpreis * (1 - (p.rabatt || 0) / 100)
    return sum + netto
  }, 0)
}

export const BESUCH_TYP_LABEL: Record<string, string> = {
  service: 'Service',
  verkauf: 'Verkauf',
  installation: 'Installation',
  garantie: 'Garantie',
  demo: 'Demo',
  notfall: 'Notfall',
}

export const BESUCH_STATUS_LABEL: Record<string, string> = {
  geplant: 'Geplant',
  unterwegs: 'Unterwegs',
  abgeschlossen: 'Abgeschlossen',
  abgesagt: 'Abgesagt',
}

export const DEFEKT_ZUSTAND_LABEL: Record<string, string> = {
  leicht: 'Leicht',
  mittel: 'Mittel',
  schwer: 'Schwer',
  'total-ausfall': 'Totalausfall',
}

export const DEFEKT_STATUS_LABEL: Record<string, string> = {
  offen: 'Offen',
  'in-bearbeitung': 'In Bearbeitung',
  behoben: 'Behoben',
}

export const OFFERT_STATUS_LABEL: Record<string, string> = {
  entwurf: 'Entwurf',
  gesendet: 'Gesendet',
  angenommen: 'Angenommen',
  abgelehnt: 'Abgelehnt',
  abgelaufen: 'Abgelaufen',
}

export const GERAET_STATUS_LABEL: Record<string, string> = {
  aktiv: 'Aktiv',
  defekt: 'Defekt',
  ersetzt: 'Ersetzt',
  entfernt: 'Entfernt',
}

export function garantieStatus(garantie_bis: string | null | undefined): 'gueltig' | 'bald' | 'abgelaufen' {
  if (!garantie_bis) return 'abgelaufen'
  const bis = new Date(garantie_bis)
  const jetzt = new Date()
  const in90Tagen = new Date(jetzt.getTime() + 90 * 24 * 60 * 60 * 1000)
  if (bis < jetzt) return 'abgelaufen'
  if (bis < in90Tagen) return 'bald'
  return 'gueltig'
}
